export enum RFQApi {
  GetProductsByText = '/api/rfq/upload-free-text',
  GetProductsByUrl = '/api/rfq/upload-url-html',
  GetJobIdByFile = '/api/rfq/upload',
  GetJobIdByUrl = '/api/rfq/upload-url',
  GetProductsById = '/api/rfq/result',
  GetJobStatus = '/api/rfq/status',
  GetProductDetails = '/api/competitor-product/summary',
  GetProductsByImageUrl = '/api/rfq/upload-image-url',
  GetProductsByManufacturer = '/api/rfq/upload-mfg-sku-name'
}

export enum AutoRFQApi {
  Create = '/rfq',
  GetAll = '/rfq/',
  GetSingle = '/rfq/:id',
  Update = '/rfq/:id',
  GetMatchedItems = '/rfq/matched',
  GetItems = '/rfq/items/:id',
  SaveItems = '/rfq/items/:id',
  UpdateItems = '/rfq/items/:id',
  DeleteSingle = '/rfq/:id',
  GenerateCSV = '/rfq/csv/:id'
}
